/**
 * SKIP-TO-CONTENT LINK
 *
 * Visible only when focused via Tab. Jumps the caret into the main
 * content region, skipping the header/nav for screen-reader + keyboard
 * users. Mount this as the very first element inside <BrowserRouter>
 * so it's the first thing a Tab press hits.
 *
 * Pair it with `<main id="main-content" tabIndex="-1">` in the layout.
 */
import React from 'react';

export const SkipToContent = ({ targetId = 'main-content' }) => {
  const onClick = (e) => {
    const el = document.getElementById(targetId);
    if (el) {
      e.preventDefault();
      el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: false });
      // Clean up tabindex so normal tab order isn't disturbed.
      setTimeout(() => el.removeAttribute('tabindex'), 500);
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={onClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[200] focus:px-4 focus:py-2 focus:bg-slate-900 focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
